import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect, useState } from "react";
import { SubAdmin } from "../../types/General";
import { useLazySubAdminByIdQuery } from "../../service/subAdmin";
import { showError } from "../../constants/toasts";
import { formatDubaiDateTime } from "../../utils/dateTime";
import Loader from "../../constants/Loader";
const SubadminDetail = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const [getSubAdminById] = useLazySubAdminByIdQuery()
  const goBack = () => {
    navigate(-1);
  };

  const [loading, setLoading] = useState(false);
  const [subAdminData, setSubAdminData] = useState<SubAdmin | null>(null);

  const getSubAdminByIdApi = async () => {
    try {
      setLoading(true)
      const response = await getSubAdminById({ id }).unwrap();
      setLoading(false)
      if (response.status === 200) {
        setSubAdminData(response?.data || "")
      }
    } catch (error: any) {
      setLoading(false)
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getSubAdminByIdApi();
  }, []);


  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title">
        <h1 className="back_arrow">
          {" "}
          <IconButton onClick={() => goBack()}>
            {" "}
            <ArrowBackIcon />{" "}
          </IconButton>{" "}Sub-Admin Detail</h1>

      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="vew_img w_100">
            <h6>Image</h6>
            <figure>
              <img alt="user" src={subAdminData?.profileImage || "/static/images/user_placeholder.png"} />
            </figure>
          </div>
          <div className="w_33">
            <h6>Name</h6>
            <p>{subAdminData?.name || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Email Id</h6>
            <p>{subAdminData?.email || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Phone Number</h6>
            <p>{`${subAdminData?.countryDialCode ? `+${subAdminData?.countryDialCode}` : ""} ${subAdminData?.phoneNumber || "-"}`}</p>
          </div>
          <div className="w_33">
            <h6>Role</h6>
            <p>{subAdminData?.roles?.name || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>{subAdminData?.createdAt ? formatDubaiDateTime(subAdminData?.createdAt) : "-"}</p>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default SubadminDetail;
